module.exports = __webpack_public_path__ + "static/img/page1.f66543a7.jpg";